import * as auth from './auth';
import * as org from './org';
import * as calls from './calls';
import * as contacts from './contacts';
import * as employees from './employees';
import * as insights from './insights';
import * as billing from './billing';
import * as ai from './ai';
import * as webhooks from './webhooks';
import * as exclusions from './exclusions';
import * as integrations from './integrations';

export const liveApi = {
  auth,
  org,
  calls,
  contacts,
  employees,
  insights,
  billing,
  ai,
  webhooks,
  exclusions,
  integrations,
};

export type Api = typeof liveApi;

let current: Api = liveApi;

/** Swap the implementation (demo mode installs fixtures before first render). */
export function installApi(next: Api) {
  current = next;
}

export const api: Api = new Proxy({} as Api, {
  get: (_target, key) => current[key as keyof Api],
});
